export const version = {
  timeStamp: '2026-10-05 06:25:26 PM -03',
  version: '0.0.13-20261005182526',
}
